const site = "IoT3";

const setCookie = (name, value, days) => {
  const d = new Date();
  d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
  document.cookie = `${name}=${value};path=/;expires=${d.toGMTString()}`;
};
// setCookie(`accessToken_IoT3`, message.token, 1);

const getCookie = (name = `accessToken_${site}`) => {
  const v = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
  return v ? v[2] : null;
};

const deleteCookie = (name = `accessToken_${site}`) => {
  setCookie(name, "", -1);
};

const logOut = () => {
  deleteCookie();
  // 清掉品牌快取，避免下一位使用者在這台瀏覽器看到前一間公司的品牌
  // （主題偏好 iot3_theme_preference 保留，那是網管在這台機器的個人設定）
  try {
    localStorage.removeItem("iot3_branding_cache");
  } catch (e) {
    /* ignore */
  }
};

export { logOut, setCookie, getCookie };